import React from 'react';
import {useSelector} from 'react-redux';

import {Formik, FastField} from 'formik';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import SendIcon from '@mui/icons-material/Send';

import BasicTextField from 'components/ui/Form/BasicTextField';

import {DocumentFormValues} from 'pages/Template/types';

import useTemplateActions from 'pages/Template/hooks/useTemplateActions';
import * as selectors from 'pages/Template/slice/selectors';

import RateConfirmation from './components/RateConfirmation';

import validation from './validation';

const Form: React.FC = () => {
    const {sendSign} = useTemplateActions();

    const templateData = useSelector(selectors.getTemplateData);

    if (!templateData) {
        return null;
    }

    const onSubmit = (values: DocumentFormValues): void => {
        sendSign(values);
    };

    return (
        <Formik initialValues={{author: ''}} validationSchema={validation} onSubmit={onSubmit}>
            {({values, dirty}) => (
                <>
                    <Toolbar
                        sx={{
                            padding: {xs: '0 20px', md: '0 60px'},
                        }}
                    >
                        <Typography variant="h6" component="div" sx={{flexGrow: 1}}>
                            {`RC-${templateData.loadNumber}.pdf`}
                        </Typography>
                        <Button
                            disabled={!dirty}
                            variant="contained"
                            endIcon={<SendIcon />}
                            onClick={() => onSubmit(values)}
                            size="large"
                        >
                            SIGn
                        </Button>
                    </Toolbar>
                    <Box
                        sx={{
                            display: {md: 'block', lg: 'flex'},
                            backfaceVisibility: 'hidden',
                            alignItems: 'flex-start',
                            justifyContent: 'center',
                            '& > :not(style)': {
                                m: {xs: '10px', sm: '15px', md: '20px'},
                                width: {md: 'auto', lg: 1080},
                            },
                            backgroundColor: {
                                xs: 'transparent',
                                lg: '#f5f5f5',
                            },
                        }}
                    >
                        <Paper elevation={3}>
                            <RateConfirmation template={templateData}>
                                <FastField name="author" component={BasicTextField} />
                            </RateConfirmation>
                        </Paper>
                    </Box>
                </>
            )}
        </Formik>
    );
};

export default Form;
